// extracted by mini-css-extract-plugin
module.exports = {"header":"DashboardCardHeader_header__NIV0d","skeleton":"DashboardCardHeader_skeleton__248j5","title":"DashboardCardHeader_title__27bTb","text":"DashboardCardHeader_text__1mb0S"};